module.exports = __webpack_public_path__ + "img/text_active.4a1d0404.svg";